import UIStrings from '@/Utils/UIStrings';

interface VerifyEmailInstructionsProps {
    email: string;
}

function VerifyEmailInstructions({ email }: VerifyEmailInstructionsProps) {
    return (
        <div className="flex flex-col gap-5 px-5 pt-5 pb-10">
            <h2 className="text-foreground text-xl font-semibold tracking-tight md:text-2xl">
                {UIStrings.VerifyYourEmailToStartUsingTalentMesh}
            </h2>
            <p className="text-foreground text-base leading-relaxed">
                <span>{`${UIStrings.VerifyEmailInstructions1} `}</span>
                <span className="font-bold">{`${email}. `}</span>
                <span>{UIStrings.VerifyEmailInstructions2}</span>
            </p>
        </div>
    );
}

export default VerifyEmailInstructions;
